import React, { useEffect, useState } from 'react';

const S = {
  wrap: { padding: '24px 16px', maxWidth: 480, margin: '0 auto', textAlign: 'center' },
  title: { fontSize: 20, fontWeight: 600, marginBottom: 16 },
  list: { display: 'flex', flexDirection: 'column', gap: 12 },
  item: {
    padding: '16px 20px', borderRadius: 12, border: '1px solid #ddd',
    background: '#fff', cursor: 'pointer', fontSize: 16, textAlign: 'left',
  },
  name: { fontWeight: 600, fontSize: 16 },
  reg: { color: '#666', fontSize: 13, marginTop: 2 },
  error: { color: '#c00', padding: 16 },
  empty: { color: '#666', padding: 16 },
};

// Blocks the flightboard until the user picks an airplane. If the location
// only has one airplane it auto-selects silently. Selection is persisted
// in the URL as ?airplane=<id>.

export default function AirplaneSelector({ locationId, onSelect }) {
  const [airplanes, setAirplanes] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`/api/mobile/airplanes?locationId=${encodeURIComponent(locationId)}`, {
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) throw new Error(`airplanes ${res.status}`);
        const data = await res.json();
        if (cancelled) return;
        setAirplanes(data);
        if (Array.isArray(data) && data.length === 1) {
          onSelect(data[0].objectId);
        }
      } catch (err) {
        if (!cancelled) setError(err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [locationId, onSelect]);

  if (error) {
    return <div style={S.wrap}><div style={S.error}>Failed to load airplanes: {error}</div></div>;
  }

  if (!airplanes) {
    return (
      <div style={S.wrap}>
        <div className="spinner" />
        <div className="loading-text">Loading airplanes…</div>
      </div>
    );
  }

  if (airplanes.length === 0) {
    return <div style={S.wrap}><div style={S.empty}>No airplanes configured for this location.</div></div>;
  }

  if (airplanes.length === 1) {
    return null;
  }

  return (
    <div style={S.wrap}>
      <div style={S.title}>Choose an airplane</div>
      <div style={S.list}>
        {airplanes.map((a) => (
          <button
            key={a.objectId}
            style={S.item}
            onClick={() => onSelect(a.objectId)}>
            <div style={S.name}>{a.shortName || a.registration || a.objectId}</div>
            {a.registration && a.registration !== a.shortName && (
              <div style={S.reg}>{a.registration}</div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
